(ns frontend.view.entity-viewers.modules.associated-entities
  (:require
   [frontend.state.current-session :as session]
   [reagent.core :as r]
   [frontend.view.modals.association.view :as association-modal]
   [common.localization :as loc]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [frontend.logging :as logging]
   [frontend.actions.entity :as entity-actions]
   [frontend.utils :as fu]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.textarea.view :as textarea-modal]
   [basic-components.html-table.table :as table]
   [basic-components.html-table.cell :as table-cell]
   [common.util :as cu]
   [common.schema.entity-type-names :as entity-type-names]
   [frontend.state.permissions :as f-permissions]
   [common.status :as statuses]))

(defn edit-comment
  [{:keys [row-data]}]
  (let [modify-text! (fn [text]
                       (entity-actions/*->field-update!
                        (:db/id row-data)
                        (:comment-attribute row-data)
                        text
                        (fn [_]
                          (logging/info "Update association comment success!"))
                        (fn [_]
                          (logging/info "Failed to update association comment!"))))]
    (modals/open-modal! textarea-modal/modal-key
                        {:title-text  (loc/tr :edit)
                         :button-text (loc/tr :ok)
                         :value       (:comment row-data)
                         :on-submit!  modify-text!})))

(defn remove-association
  [{:keys [row-data]}]
  (entity-actions/*->remove-association (->> row-data
                                             :viewed-entity
                                             :db/id)
                                        (:db/id row-data)
                                        (fn [_]
                                          (logging/info "Removed association OK"))
                                        (fn [err]
                                          (logging/info "Remove association Failed : " err))))

(defn other-entity-renderer
  [{:keys [column-meta row-data state]}]
  (let [{:keys [other-entity other-entity-type]} row-data]
    [table-cell/cell
     {:column-meta   (merge column-meta
                            {:column/data-type :data.type/id})
      :cell-value    (:db/id other-entity)
      :tenant-schema @session/tenant-schema
      :row-data      (merge row-data
                            {:entity/type other-entity-type})
      :state         state}]))

(defn tools-cell-renderer
  [row-data]
  (if (session/is-read-only-user?)
    [:div]
    [:div
     {:class "flex justify-end"}
     [dropdown-menu/view
      {:trigger [:i.fas.fa-ellipsis-v]
       :items   [{:value :edit-comment
                  :label     (loc/tr :edit-comment)
                  :icon-class     "fas fa-pen"
                  :on-click #(edit-comment row-data)}
                 {:value :remove
                  :label     (loc/tr :remove)
                  :icon-class    "fas fa-trash-alt"
                  :on-click #(remove-association row-data)}]}]]))

(def person-phone-attributes
  [:person/universal-phone-number
   :person/work-phone-number
   :person/mobile-phone-number])

(def default-table-first-column
  [{:column/key           :association/name
    :column/label         (loc/tr :association/name)
    :column/cell-renderer other-entity-renderer
    :column/data-type     :data.type/text
    :column/class-name    "clickable"
    :column/sortable?     true}])

(def default-table-last-columns
  [{:column/key        :comment
    :column/label      (loc/tr :association/comment)
    :column/data-type  :data.type/text-multiline
    :column/class-name "comment-col"
    :column/tooltip?   true}
   {:column/key           :tools
    :column/header-renderer (fn [_] "")
    :column/cell-renderer tools-cell-renderer
    :column/class-name    "text-center tools-col"}])

(def default-table-columns
  (concat default-table-first-column
          default-table-last-columns))

(def oppo-table-columns
  (concat default-table-first-column
          [{:column/key           :oppo/stage
            :column/label         (loc/tr :oppo/stage)
            :column/cell-renderer (fn [data]
                                    (let [oppo-stage-id (->> data
                                                             :row-data
                                                             :other-entity
                                                             :oppo/stage)
                                          oppo-stage-name (->> (get @session/entities oppo-stage-id)
                                                               :stage/name)]
                                      oppo-stage-name))
            :column/value-getter  (fn [row-data]
                                    (let [oppo-stage-id (->> row-data
                                                             :other-entity
                                                             :oppo/stage)
                                          oppo-stage-name (->> (get @session/entities oppo-stage-id)
                                                               :stage/name)]
                                      oppo-stage-name))
            :column/data-type     :data.type/text
            :column/sortable?     true}
           {:column/key           :oppo/status
            :column/label         (loc/tr :oppo/status)
            :column/cell-renderer (fn [data]
                                    (let [oppo-status-key (->> data
                                                               :row-data
                                                               :other-entity
                                                               :oppo/status)
                                          oppo-status-name (->> statuses/oppo-status-options
                                                                (filter (fn [option]
                                                                          (= (:key option)
                                                                             oppo-status-key)))
                                                                (first)
                                                                :label)]
                                      oppo-status-name))
            :column/value-getter  (fn [row-data]
                                    (let [oppo-status-key (->> row-data
                                                               :other-entity
                                                               :oppo/status)
                                          oppo-status-name (->> statuses/oppo-status-options
                                                                (filter (fn [option]
                                                                          (= (:key option)
                                                                             oppo-status-key)))
                                                                (first)
                                                                :label)]
                                      oppo-status-name))
            :column/data-type     :data.type/text
            :column/sortable?     true}]
          default-table-last-columns))

(def person-table-columns
  (concat
   default-table-first-column
   [{:column/key           :person/universal-email-address
     :column/label         (loc/tr :person/universal-email-address)
     :column/cell-renderer (fn [data]
                             (let [person-email (->> data
                                                     :row-data
                                                     :other-entity
                                                     :person/universal-email-address)]
                               [:a.associations-person-email
                                {:href (str "mailto:" person-email)}
                                person-email]))
     :column/value-getter  (fn [row-data]
                             (let [person-email (->> row-data
                                                     :other-entity
                                                     :person/universal-email-address)]
                               person-email))
     :column/data-type     :data.type/text
     :column/sortable?     true}]
   (when (->> person-phone-attributes
              (some #(f-permissions/field-read-access? % :entity.type/person nil)))
     [{:column/key           :person/universal-phone-number
       :column/label         (loc/tr :person/universal-phone-number)
       :column/cell-renderer (fn [data]
                               (->> person-phone-attributes
                                    (keep
                                     (fn [attribute]
                                       (when (f-permissions/field-read-access? attribute
                                                                               :entity.type/person
                                                                               nil)
                                         (get-in data [:row-data :other-entity attribute]))))
                                    (first)))
       :column/value-getter  (fn [row-data]
                               (->> person-phone-attributes
                                    (keep
                                     (fn [attribute]
                                       (when (f-permissions/field-read-access? attribute
                                                                               :entity.type/person
                                                                               nil)
                                         (get-in row-data [:other-entity attribute]))))
                                    (first)))
       :column/data-type     :data.type/text
       :column/sortable?     true}])
   default-table-last-columns))

(defn table-columns
  [entity-type _source-type]
  (case entity-type
    :entity.type/oppo oppo-table-columns
    :entity.type/person person-table-columns
    :entity.type/company default-table-columns
    default-table-columns))

(defn module-content
  [_]
  (let [table-state (r/atom {})]
    (fn [{:keys [entity-type source-type associations] :as _args}]
      [table/view associations
       {:id-key       :db/id
        :table-key    "associated-entities"
        :class-name   "w-100"
        :state        table-state
        :group-by-key :entity-association/type
        :columns      (table-columns entity-type source-type)
        :settings     {:show-selection?     true
                       :show-filters?       true
                       :show-grouping?      false
                       :show-sorting?       true
                       :default-sort-key    :association/name
                       :column-order        [:db/id :entity/type :common/created-on]
                       :sticky-column-group 0
                       :on-row-select       (fn [selected-id selected?]
                                              (if selected?
                                                (swap! table-state assoc :selected-id selected-id)
                                                (swap! table-state dissoc :selected-id)))}}])))

(defn open-create-association-modal
  [source-entity entity-type]
  (modals/open-modal! association-modal/modal-key
                      {:entity-id      (:db/id source-entity)
                       :entity-type    (:entity/type source-entity)
                       :target-type    entity-type
                       :create-on-fly? (not= entity-type :entity.type/oppo)}))

(defn add-new-association-button
  [target-type viewed-entity]
  [:div
   (when-not (session/is-read-only-user?)
     [fu/tooltip-overlay
      {:id (str "add-association-" target-type "-" (:db/id viewed-entity))}
      (loc/tr :add-association-tooltip [(loc/tr target-type)])
      [:i
       {:class-name (fu/cs "fal clickable fa-plus-circle")
        :on-click   (fn [_]
                      (open-create-association-modal viewed-entity target-type))}]])])

(defn resolve-row-data
  [entity association]
  (let [entity-id (:db/id entity)
        source-entity-id (fu/ref->id (:entity-association/source-entity association))
        target-entity-id (fu/ref->id (:entity-association/target-entity association))
        entity-is-source? (= entity-id source-entity-id)
        other-entity-id (if entity-is-source?
                          target-entity-id
                          source-entity-id)
        other-entity @(r/track session/get-entity other-entity-id)
        comment-attribute (if entity-is-source?
                            :entity-association/source-comment
                            :entity-association/target-comment)]
    (merge association
           {:viewed-entity     entity
            :other-entity      other-entity
            :other-entity-type (:entity/type other-entity)
            :association/name  @(r/track fu/resolve-name other-entity)
            :comment-attribute comment-attribute
            :comment           (get association comment-attribute)
            :trunc-limit       (if (= :entity.type/person (:entity/type other-entity))
                                 20
                                 50)})))

(defn modules
  [{:keys [save-module-collapsed! header-fn module-collapsed-path entity-id]}]
  (let [entity @(r/track session/get-entity entity-id)
        associations @(r/track fu/get-entity-associations entity-id)
        row-datas-per-entity-type (->> associations
                                       (map (partial resolve-row-data entity))
                                       (group-by :other-entity-type))
        allowed-types (fu/allowed-association-entity-types (:entity/type entity))]
    (->>
     allowed-types
     (keep
      (fn [target-type]
        (let [module-id (keyword "association" (name target-type))
              row-datas (get row-datas-per-entity-type target-type)]
          (when (or (not (session/is-read-only-user?))
                    (seq row-datas))
            {:module-id              module-id
             :header                 (if (fn? header-fn)
                                       (header-fn {:entity entity
                                                   :target-type target-type})
                                       (loc/tr :associated-
                                           [(cu/str-trim-lcase
                                             (entity-type-names/get-plural target-type :en))]))
             :header-tools           (add-new-association-button target-type entity)
             :target-type            target-type
             :create-new-fn          (fn [_]
                                       (open-create-association-modal entity target-type))
             :collapsed?             @(r/track session/get-view-config (module-collapsed-path module-id))
             :start-collapsed?       (empty? row-datas)
             :has-data?              (seq row-datas)
             :save-module-collapsed! (r/partial save-module-collapsed! (:entity/type entity))
             :content                [:div
                                      (if (empty? row-datas)
                                        [:h2
                                         {:class "mb-0 pt-2 px-1 text-base-light-text-paler text-sm"}
                                         (loc/tr :no-associations-info-text
                                             [(cu/str-trim-lcase (entity-type-names/get-plural target-type
                                                                                               :en))])]
                                        [:div
                                         {:class "flex flex-col gap-2 overflow-x-auto"}
                                         [module-content
                                          {:associations row-datas
                                           :source-type  (:entity/type entity)
                                           :entity-type  target-type}]])]}))))
     (doall))))
